module.exports = __webpack_public_path__ + "img/pool.f6995a93.png";